export default "__VITE_ASSET__DVV0rFLU__"